export const parseUrlParts = (url: string | undefined) => {
  if (!url) return undefined;
  const parsed = new URL(url);

  const hostnameParts = parsed.hostname.split('.');
  const rootDomain = hostnameParts.slice(-2).join('.');

  const getDomainUrl = () => {
    return `${result.protocol}://${result.subdomain ? result.subdomain + result.separator : ''}${result.rootDomain}`;
  };

  const result = {
    protocol: parsed.protocol.replace(':', ''),
    subdomain: hostnameParts.length > 2 ? hostnameParts.slice(0, -2).join('.') : '',
    rootDomain,
    fullDomain: parsed.hostname,
    port: parsed.port || '',
    path: parsed.pathname,
    query: parsed.search,
    hash: parsed.hash,
    origin: parsed.origin,
    separator: '.',
    getDomainUrl,
  };

  return result;
};
